export default {"src":"https://web.cdn.greenlight.com/2.1355.1/_next/static/media/cog-icon.a1e3bdd7.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};